/**
 * created by panjm on 2019-10-24
 *
 * description： 首页
 *
 */
import './index.scss';
import utils from 'libs/utils';
import config from 'libs/config';
import PageInit from 'libs/init.js';
import http from 'libs/http';
import api from 'api';

import Page from 'template/page/page';
import Dialog from 'libs/dialog';
import HeaderTpl from 'template/dot/layout/header';
import LeftTpl from 'template/dot/layout/left';
import Pagination from 'template/dot/layout/pagination';

import MainTpl from './module/main.dot';
import SearchTpl from './module/search.dot';
import WaitListTpl from './module/wait-list.dot';
import AuditedListTpl from './module/audited-list.dot';
import DialogTpl from './module/dialog.dot';
import consts from 'consts';
const Base64 = require('js-base64').Base64;

class Handle extends Page{
	/**
	 * description： 构造函数
	 * @param {Object} 属性集合
	 *
	 * created by panjm on 2019-10-24
	 *
	 */
	constructor() {
		super();
		// 初始化html容器
		this.mainContainer = $('#main');

		// 当前tab
		this.curTab = 1;

		// 待审批-静态数据页码
		this.waitParams = {
			page: 1,
			size: 10
		};

		// 已审批-静态数据页码
		this.auditedParams = {
			page: 1,
			size: 10
		};

		// 全局列表数据
		this.tabelList = [];
	}

	/**
	 * description： 渲染页面
	 *
	 * created by panjm on 2019-10-24
	 *
	 */
	render() {
		// 初始化头部实例
		this.header = new HeaderTpl({level: 1});
		// 渲染头部html
		this.header.render();

		// 开启页面loading效果
		utils.pageLoading();

		// 页面初始化
		this.pageInit = new PageInit();
		// 获取登录用户的信息
		this.pageInit.APIInit().then(() => {
			// sid
			this.sid = this.pageInit.sid;
			this.sid =utils.getUrlParams()['sid'] || this.sid 
			// 获取按钮权限
			this.btnAuths = this.pageInit.btnAuths;
			if(!this.btnAuths[consts.AUTHS.BTN_AUTH['审批处理-查看']]) {
				if(this.btnAuths[consts.AUTHS.BTN_AUTH['我提交的审批-查看']]) {
					utils.href('mine/index.html');
				} else if(this.btnAuths[consts.AUTHS.BTN_AUTH['审批设置-查看']]) {
					utils.href('setting/index.html');
				} else {
					utils.href('noauth/index.html');
					return;
				}
			}

			// 关闭页面loading效果
			utils.unPageLoading();

			// 获取用户信息
			let user = this.pageInit.user;

			// 内容区模版数据
			let data = {
				dpath: utils.getDpath(1),
				curTab: this.curTab
			};

			// 渲染主内容区
			this.mainContainer.html(utils.replacePath(MainTpl(data)));

			// 渲染查询条件
			this.renderSearch();

			// 刷新头部用户信息和消息中心统计数量
			this.header.refreshHTML(user);

			// 初始化左侧实例
			this.left = new LeftTpl({
				level: 1,
				btnAuths: this.btnAuths
			});

			// 渲染左侧html
			this.left.render();
			// 获取列表数据
			this.getData();

			// 渲染审批/查看弹窗
			this.handleDialog = new Dialog({
				pkid: 'handle',
				title: '集团集采管理审批',
				contentHTML: utils.replacePath(DialogTpl({
					isAudit: false,
					auditBtn: this.btnAuths[consts.AUTHS.BTN_AUTH['审批处理-审核']]
				})),
				closeFn: function() {
					http.abortAll();
				}
			});
		}).catch((err) => {
		});

		// 绑定事件
		this.bindEvent();
	}

	/**
	 * description：渲染查询条件
	 *
	 * created by panjm on 2019-10-24
	 *
	 */
	renderSearch(){
		// 判断当前tab
		if(this.curTab === 1){
			// 重置当前tab列表分页数据
			this.waitParams = {
				page: 1,
				size: 10
			};
		} else if(this.curTab === 2){
			// 重置当前tab列表分页数据
			this.auditedParams = {
				page: 1,
				size: 10
			};
		}
		// 渲染查询条件
		$('#search').html(utils.replacePath(SearchTpl({
			curTab: this.curTab,
			checkCodes: this.pageInit.checkCodes,
			batchAuditBtn: this.btnAuths[consts.AUTHS.BTN_AUTH['审批处理-批量审核']],
			plats: this.pageInit.plats,
			curPlat: this.pageInit.plats.filter(item => item.sid === this.sid)[0]
		})));
	}

	/**
	 * description： 绑定事件
	 *
	 * created by panjm on 2019-10-24
	 *
	 */
	bindEvent() {
		let that = this;

		// 选项卡【待我审批/我已审批】点击切换事件绑定
		$('body').on('click', '.handle_tab span', function(){
			// 保存当前tab索引值
			that.curTab = $(this).data('index');
			// 切换tab选中样式
			$('.handle_tab span').removeClass('lgc_glass');
			$(this).addClass('lgc_glass');
			// 渲染查询条件
			that.renderSearch();
			// 切换之前打断所有请求
			http.abortAll();
			// 刷新列表
			that.getData();
		});

		// 【下拉选择框】显示/收起下拉选项事件绑定
		$('body').on('click', '.spzx_selbox .slidkey',function(){
			let n = $(this).index('.spzx_selbox .slidkey');

			$(`.slidkey_hide:not(:eq(${n}))`).slideUp(200);
			$(this).parent().find('.slidkey_hide').slideToggle(200);
			return false;
		});

		// 【下拉选择框】选中下拉选项事件绑定
		$('body').on('click', '.slidkey_hide li', function(){
			// 收起下拉选项
			$(this).parent().slideUp(200);
			// 获取选中项label值
			let stxt = $(this).text();
			// 设置选中项label值

			$(this).parent().parent().find('em').html(stxt);
			// 获取选中项value值
			let code = $(this).data('code');
			// 设置选中项value值

			$(this).parent().parent().find('input').val(code);
			// 设置当前选中项样式
			$(this).parent().siblings('.slidkey').addClass('on');
		});

		//【下拉选择框】点击下拉选择框外的地方收起下拉选项事件绑定
		$(document).bind('click',function(e){
			let target=$(e.target);

			if (target.closest('.slidkey_hide').length == 0){
				$('.slidkey_hide').slideUp(200);
			}
		});

		// 操作【查看/审批】打开弹窗事件绑定
		$('body').on('click', '.handle_wrap .spzx_view', function(){
			// 显示弹窗
			that.handleDialog.open();

			// 获取当前审批名称
			let checkObjName = that.tabelList[$(this).data('index')].checkObjName;

			// 判断当前tab
			if(that.curTab === 1){
				// 修改弹窗标题
				$('#dialog_handle .dialog_title').text(`${checkObjName}审批`);
			} else {
				// 修改弹窗标题
				$('#dialog_handle .dialog_title').text(`${checkObjName}查看`);
			}

			// 请求弹窗数据
			that.getAuditDetail($(this).data('index'));

			// 判断当前状态是否已读
			if(!$(this).parents('tr').hasClass('read') && that.curTab === 1) {
				// 设置已读状态
				that.setReadStatus(that.tabelList[$(this).data('index')]).then(() => {
					// 已读置灰
					$(this).parents('tr').addClass('read');
					// 去掉未查看标识
					$(this).parents('tr').find('.unread').addClass('read').text('已读');
				});
			}

		});

		// 按钮【关闭】查看/审批弹窗事件绑定
		$('body').on('click', '#dialog_content_handle .close_dialog_btn', function(){
			// 关闭弹窗
			that.handleDialog.close();
		});

		// 按钮【查询】事件绑定
		$('body').on('click', '#search .search_btn', function(){
			// 查询打断上一个请求
			http.abortAll();
			// 判断当前tab
			if(that.curTab === 1){
				// 重置当前tab列表分页数据
				that.waitParams = {
					page: 1,
					size: 10
				};
			} else if(that.curTab === 2){
				// 重置当前tab列表分页数据
				that.auditedParams = {
					page: 1,
					size: 10
				};
			}

			// 请求接口处理
			that.getData();
		});

		// 按钮【清空】事件绑定
		$('body').on('click', '#search .clear_btn', function(){
			// 清空查询条件
			$('#search input[name=\'checkObjId\']').val('');
			$('#search input[name=\'logStatus\']').val('');
			$('#search input[name=\'statusList\']').val('');
			// 重置下拉选择器placeholder文字
			$('#search li:not(.search_plats) em').text('请选择');
			// 修改文本框文字颜色样式
			$('#search li:not(.search_plats) .slidkey').removeClass('on');
			// 请求接口处理
			// that.getData();
		});

		// 按钮【同意】事件绑定
		$('body').on('click', '#dialog_content_handle .agree_btn', function(){
			let self = this;
			// 组装提示框参数配置
			let options = {
				title: '提示',
				message: '确认同意？',
				zIndex: 1001,
				success: function() {
					that.agree(that.tabelList[$(self).data('index')]);
				},
				cancel: function() {

				}
			};

			// 打开提示框
			utils.confirm(options);
		});

		// 按钮【驳回】事件绑定
		$('body').on('click', '#dialog_content_handle .refuse_btn', function(){
			let self = this;
			// 组装提示框参数配置
			let options = {
				title: '驳回理由',
				type: 'textarea',
				placeholder: '请输入驳回理由',
				zIndex: 1001,
				maxlength: 200,
				checkText: '驳回理由最多输入200个字',
				isClose: false,
				success: function(value) {
					that.refuse(that.tabelList[$(self).data('index')], value);
				}
			};

			// 打开提示框
			utils.confirm(options);
		});


		// 按钮【批量审批】事件绑定
		$('body').on('click', '.batch_btn', function() {
			// 判断有无数据
			if(!that.getCheckedData()) {
				return;
			}

			// 二次弹窗确认【新选择批量审批结果】
			utils.confirm({
				title: '批量审批',
				message: '请选择批量审批结果',
				success: function() {
					// 二次弹窗确认【请您确认是否全部通过所勾选内容的审批】
					utils.confirm({
						title: '批量审批通过确认',
						message: '请您确认是否全部通过所勾选内容的审批',
						isClose: false,
						success: function() {
							that.batchAudit(that.getCheckedData(1), 1);
						},
						cancel: function() {

						}
					});
				},
				cancel: function() {
					// 二次弹窗确认【请输入驳回理由】
					utils.confirm({
						title: '批量审批驳回确认',
						type: 'textarea',
						placeholder: '请输入驳回理由',
						zIndex: 1001,
						maxlength: 200,
						checkText: '驳回理由最多输入200个字',
						isClose: false,
						success: function(value) {
							that.batchAudit(that.getCheckedData(9, value), 9);
						},
						cancel: function() {

						}
					});
				}
			});

			// 调整样式文字结构
			$('.spzx_buttons').css('text-align', 'center');
			$('.spzx_buttons .agree').text('批量审批通过');
			$('.spzx_buttons .close').text('批量审批驳回');
		});

		// 复选框事件绑定
		$('body').on('click', '.cklabel', function(e){
			// 阻止事件重复触发
			if(e.target.nodeName !== 'INPUT') {
				return;
			}

			// 获取checkbox选中状态
			let isChecked = $(this).find('input[type=\'checkbox\']').attr('checked') || false;

			if(isChecked){
				// 绑定选中样式
				$(this).parents('tr').find('.choose').addClass('sel');
				$(this).parents('tr').find('input[type=\'checkbox\']').attr('checked', true);
			} else {
				// 取消选中样式
				$(this).parents('tr').find('.choose').removeClass('sel');
				$(this).parents('tr').find('input[type=\'checkbox\']').attr('checked', false);
			}
		});
	}

	/**
	 * description: 获取按供应商查看列表
	 *
	 * created by panjm on 2019-10-24
	 *
	 */
	getData() {
		// 打开loading效果
		utils.tableLoading('.handle_wrap .loading_wrap');

		// 分页参数
		let pageParams = {};
		// 列表模板
		let listTpl = null;
		// 查询条件
		let filters = {};

		// 判断当前tab
		if(this.curTab === 1){
			// 获取当前tab列表分页数据
			pageParams = this.waitParams;
			// 获取查询条件
			filters = {
				checkObjId: $('#search input[name=\'checkObjId\']').val() || '',
				// logStatusList: [0]
				logStatus: 100
			};
			// 获取当前tab列表模板
			listTpl = WaitListTpl;
		} else if(this.curTab === 2){
			// 获取当前tab列表分页数据
			pageParams = this.auditedParams;
			// 获取查询条件
			filters = {
				checkObjId: $('#search input[name=\'checkObjId\']').val() || '',
				// logStatusList: $('#search input[name=\'logStatusList\']').val()? [Number($('#search input[name=\'logStatusList\']').val())]: [1,2,9],
				logStatus: $('#search input[name=\'logStatus\']').val()? Number($('#search input[name=\'logStatus\']').val()): 200,
				statusList: $('#search input[name=\'statusList\']').val() || '',
			};
			// 获取当前tab列表模板
			listTpl = AuditedListTpl;
		}

		// 请求参数
		let params = {
			url: api.handle.getList,
			type: 'POST',
			data: {
				...pageParams,
				...filters,
				sid: this.sid,
				ssid: config.SSID,
				orderByClause:'createDate desc'

			}
		};

		// 远程调用
		http.ajax(params, res => {
			// 全局列表数据
			this.tabelList = res.data.list;

			// 关闭表格loading效果
			utils.unTableLoading('.handle_wrap .loading_wrap');
			// 分页参数
			pageParams = { ...pageParams,
				...{
					currPage: res.data.currPage,
					pageSize: res.data.pageSize,
					totalCount: res.data.totalCount,
					totalPage: res.data.totalPage
				}
			};

			// 渲染列表
			this.mainContainer.find('.spzx_tableTemp').html(utils.replacePath(listTpl({
				list: res.data.list || [],
			})));

			// 初始化按集采品种查看列表分页
			this.pagination = new Pagination({
				binding: '#pagination',
				pageData: pageParams,
				callback: this.changePage.bind(this)
			});
			// 渲染分页
			this.pagination.render();
		}, err => {
			// 关闭表格loading效果
			utils.unTableLoading('.handle_wrap .loading_wrap');
		});
		if(this.curTab === 1) {
			// 获取待审核数量
			this.getWaitAduitCount();
		}
	}

	/**
	 * description： 获取弹窗详情
	 * @param {Number} index 序号
	 *
	 * created by panjm on 2019-10-24
	 */
	getAuditDetail(index){
		// 开启弹窗加载效果
		utils.tableLoading('#dialog_content_handle');

		// 组装请求数据
		let params = {
			// 请求地址
			url: api.handle.getAuditDetail,
			// 请求参数
			params: {
				ywid: this.tabelList[index].ywid,
				checkGroupId: this.tabelList[index].checkGroupId,
				sid: this.tabelList[index].sid,
				checkDataId: this.tabelList[index].pkid
			}
		};

		// 发送接口请求
		http.ajax(params, (res) => {
			// 关闭弹窗加载效果
			utils.unTableLoading('#dialog_content_handle');
			// 重新渲染弹窗内容
			this.handleDialog.update(utils.replacePath(DialogTpl({
				isAudit: this.curTab === 1,
				index: index,
				url: `${this.tabelList[index].callBackDetailUrl}?pkid=${this.tabelList[index].ywid}&gid=${this.tabelList[index].checkGroupId}&sid=${this.tabelList[index].sid}&sys=${this.tabelList[index].subsystem}&_=${new Date().getTime()}`,
				data: res.data,
				auditBtn: this.btnAuths[consts.AUTHS.BTN_AUTH['审批处理-审核']]
			})));
		}, err => {
			// 关闭弹窗加载效果
			utils.unTableLoading('#dialog_content_handle');
		});
	}

	/**
	 * description：同意
	 * @param {Object} row 对应行数据
	 *
	 * created by panjm on 2019-10-25
	 */
	agree(row){
		// 开启按钮加载状态
		utils.btnLoading('#dialog_handle .btn_loading_wrap');

		// 组装请求数据
		let params = {
			// 请求地址
			url: api.handle.agree(row.pkid),
			type: 'PUT',
			// 请求参数
			data: {
				checkDataId: row.pkid,
				status: 1,
				timemd5: row.timemd5
			}
		};

		// 发送接口请求
		http.ajax(params, (res) => {
			// 关闭按钮加载状态
			utils.unBtnLoading('#dialog_handle .btn_loading_wrap');

			// 组装提示框参数配置
			let options = {
				message: '已同意',
				type: 'success'
			};

			// 打开提示框
			utils.alert(options);
			// 关闭弹窗
			this.handleDialog.close();
			// 刷新列表
			this.getData();
		}, err => {
			// 关闭弹窗加载效果
			utils.unBtnLoading('#dialog_handle .btn_loading_wrap');
		});
	}

	/**
	 * description：驳回
	 * @param {Object} row 对应行数据
	 * @param {String} value 驳回理由
	 *
	 * created by panjm on 2019-10-25
	 */
	refuse(row, value){
		// 开启按钮加载状态
		utils.btnLoading('#dialog_handle .btn_loading_wrap');

		// 组装请求数据
		let params = {
			// 请求地址
			url: api.handle.refuse(row.pkid),
			type: 'PUT',
			// 请求参数
			data: {
				checkDataId: row.pkid,
				status: 9,
				timemd5: row.timemd5,
				refuseMsg: value
			}
		};

		// 发送接口请求
		http.ajax(params, (res) => {
			// 关闭按钮加载状态
			utils.unBtnLoading('#dialog_handle .btn_loading_wrap');

			// 组装提示框参数配置
			let options = {
				message: '已驳回',
				type: 'success'
			};

			// 打开提示框
			utils.alert(options);
			// 关闭弹窗
			this.handleDialog.close();
			// 刷新列表
			this.getData();

			utils.confirmClose();
		}, err => {
			// 关闭弹窗加载效果
			utils.unBtnLoading('#dialog_handle .btn_loading_wrap');
		});
	}

	/**
	 * description: 分页修改页码回调函数
	 *
	 * created by panjm on 2019-10-24
	 */
	changePage(page) {
		// 分页参数
		let pageParams = {};

		// 判断当前tab
		if(this.curTab === 1){
			pageParams = this.waitParams;
		} else if(this.curTab === 2){
			pageParams = this.auditedParams;
		}

		// 页码赋值
		pageParams.page = page;

		// 修改完数据后需要重新渲染
		this.getData();
	}

	/**
	 * description: 获取待审核数量
	 *
	 * created by zhouzt on 2019-11-07
	 *
	 */
	getWaitAduitCount() {
		// 请求参数
		let params = {
			url: api.handle.count,
			type: 'POST',
			data: {
				sid: this.sid,
				logStatus: 100
			}
		};

		// 远程调用
		http.ajax(params, res => {
			// 对应激活tab数字添加
			$('#total_num').text(`（${res.data}）`);
		}, err => {

		});
	}

	/**
	 * description: 设置已读状态
	 * @param {Object} row 传过来的行数据
	 *
	 * created by zhouzt on 2020-01-02
	 *
	 */
	setReadStatus(row) {
		// 请求参数
		let params = {
			url: api.handle.read,
			data: {
				readDataList: [{
					pkid: row.spCheckLog.pkid,
					readStatus: 1,
					timemd5: row.spCheckLog.timemd5
				}]
			},
			type: 'PUT'
		};

		// 远程调用
		return new Promise((resolve, reject) => {
			http.ajax(params, res => {
				resolve(res);
			}, err => {
				reject(err);
			});
		});
	}

	/**
	 * description: 获取勾选数据
	 * @param {Number} status 状态 1-审核通过，9-审核拒绝
	 * @param {String} refuseMsg 拒绝理由
	 *
	 * created by zhouzt on 2020-01-02
	 *
	 */
	getCheckedData(status, refuseMsg) {
		let that = this;
		let chooseList = [];

		if($('.spzx_tableTemp .cklabel input[checked=\'checked\']').length <= 0) {
			// 消息提示【请选择至少一条数据】
			utils.alert({
				type: 'warning',
				message: '请选择至少一条数据'
			});
			return false;
		}
		// 循环选择数据
		$('.spzx_tableTemp .cklabel input[checked=\'checked\']').each(function() {
			// 获取当前行数据
			let row = that.tabelList[$(this).data('index')];

			// 添加进数组
			chooseList.push({
				pkid: row.pkid,
				status: status,
				timemd5: row.timemd5,
				refuseMsg: refuseMsg
			});
		});

		return chooseList;
	}

	/**
	 * description: 批量审核
	 * @param {Array} list 审核数据
	 * @param {Number} status 判断状态
	 *
	 * created by zhouzt on 2020-01-02
	 *
	 */
	batchAudit(list, status) {
		// 开启按钮loading效果
		utils.btnLoading('.spzx_sure_messagebox .spzx_buttons .sureOk_label');
		// 请求参数
		let params = {
			url: api.handle.batch,
			data: {
				auditDataList: list
			},
			type: 'PUT'
		};

		// 远程调用
		http.ajax(params, res => {
			// 关闭弹窗
			utils.closeAllConfim();
			// 消息提示【审批成功】
			utils.alert({
				type: 'success',
				message: `${status === 1? '通过': '驳回'}成功`
			});

			// 刷新列表
			this.getData();
		}, err => {
			// 关闭按钮loading效果
			utils.unBtnLoading('.spzx_sure_messagebox .spzx_buttons .sureOk_label');
		});
	}

	/**
	 * description: 切换平台回调
	 *
	 * created by zhouzt on 2020-05-25
	 *
	 */
	switchPlat() {
		this.renderSearch();
		this.getData();
	}
}

// 页面实例化
let handle = new Handle();

// 渲染页面
handle.render();


// WEBPACK FOOTER //
// ./src/pages/handle/index.js